import { render, staticRenderFns } from "./BasicFreqGrid.vue?vue&type=template&id=6144dc5a"
import script from "./BasicFreqGrid.vue?vue&type=script&lang=js"
export * from "./BasicFreqGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports